"use client";

import React from "react";
import { Stack, useMediaQuery, useTheme } from "@mui/material";
import { FlexibleCard as FlexibleCardType } from "@/types/dto/flexible-card-layout-section";
import FlexibleCard from "../flexible-card";
import CarouselLayout from "./carousel-layout";

interface ColumnLayoutProps {
  cards: FlexibleCardType[];
}

const ColumnLayout: React.FC<ColumnLayoutProps> = ({ cards }) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery((theme as any).breakpoints.up("desktop"));
  
  // Show carousel on tablet and below
  if (!isDesktop) {
    return <CarouselLayout cards={cards} />;
  }
  
  return (
  <Stack 
    className="flexible-card-column-layout"
    spacing={6}
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch"
    }}
  >
    {cards.map((card, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <FlexibleCard key={`column-${index}-${card.tour?.id || "no-tour"}`} card={card} index={index} />
    ))}
  </Stack>
  );
};

export default React.memo(ColumnLayout);